import { render, staticRenderFns } from "./LmTextNumberEditorTextAreaPasswordBuilderUi.vue?vue&type=template&id=2beb8b6d&"
import script from "./LmTextNumberEditorTextAreaPasswordBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmTextNumberEditorTextAreaPasswordBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports